import React from 'react';
import NorthEastIcon from '@mui/icons-material/NorthEast';

export default function Contact() {
  return <section className="contact-section page-width" id="contact" aria-labelledby="contact-title" data-reveal><h2 id="contact-title">Contact</h2><a className="contact-link" href="mailto:akiratsuyoi2705@gmail.com">akiratsuyoi2705@gmail.com <NorthEastIcon /></a></section>;
}
